import { apiRequest } from './api';
import { hasStreetAddress } from './addressFormatting';
import type { Address, BuildingWithConvertedAddresses } from './types';

/**
 * Whether a follow can carry this address: the backend needs a street for the
 * notification text, so a district-only building (JAA-417) has none to send.
 */
export const hasSubscriptionAddress = (address: Address | null): boolean =>
  hasStreetAddress(address);

export async function toggleBuildingSubscription(
  building: BuildingWithConvertedAddresses,
  address: Address | null,
): Promise<{ is_subscribed: boolean; subscribersCount?: number }> {
  const result = await apiRequest('/toggle-subscribe-to-notifications', {
    method: 'POST',
    body: {
      selected_building: building,
      // This is the resolved heading address, which can differ from the raw
      // building's first address (or exist when that array is still empty).
      ...(hasSubscriptionAddress(address) && address
        ? {
            address: {
              street: address.street,
              houseNumber: address.houseNumber,
              city: address.city,
              postcode: address.postcode,
              region: address.region,
              country: address.country,
              coordinates: address.coordinates ?? building.centroid,
            },
          }
        : {}),
    },
  });
  if (typeof result?.is_subscribed !== 'boolean') {
    throw new Error('Invalid subscription response');
  }
  return result;
}
